<template>
  <!-- NOTE (TEMPLATE) to getting informations & commitments to complete and sending proposal as a complete proposal  -->
  <div class="animated fadeIn">
    <!-- loading component -->
    <div>
      <span v-show="false">{{ reactivity }}</span>
      <Loading />

      <b-card style="border: 0" class="mt-0 mb-0">
        <b-card
          v-if="
            proposal.status == 'نیاز به تکمیل / اصلاح' && proposal.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ errorMessage }}</b-card
        >
        <b-tabs pills fill vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <!-- NOTE (b-previousTab) to go to the previous tab -->
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <!-- NOTE (b-saveDraft) to save draft -->

            <!-- NOTE (b-nextTab) to go to the next tab -->
            <b-button
              v-if="tabIndex != 9"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>
          <b-tab :title="'عنوان و حمایت‌های پیشین'" active>
            <b-card
              header-bg-variant="#8341a4"
              header-text-variant="white"
              header="پژوهشگر مورد نظر"
              style="border: 0"
              class="shadow p-3 mb-5 bg-white rounded mt-0"
            >
              <b-form-group>
                <Select2
                  class="myselect2"
                  v-model="proposal.researcherId"
                  :options="researchers"
                  @change="showAcount()"
                  :settings="{ width: '100%' }"
                ></Select2>
              </b-form-group>
            </b-card>
            <h3>پژوهشگر گرامی</h3>

            <b-form-group>
              <div class="d-flex" dir="ltr">
                <label
                  for="switch_1"
                  :class="
                    proposal.initialObligation
                      ? 'ml-3 mb-0 done'
                      : 'ml-3 mb-0 required'
                  "
                >
                  اینجانب تعهد می کنم با مطالعه و آگاهی از
                  <b-button
                    id="downLoad"
                    title="دانلود تعهدات"
                    variant="link"
                    href="/researcher/rules/phd/شیوه نامه رساله دکتری.pdf"
                  >
                    <b-tooltip
                      placement="bottomleft"
                      target="downLoad"
                      triggers="hover"
                      variant="info"
                      >دانلود شیوه‌نامه</b-tooltip
                    >شیوه‌نامه حمایت از رساله‌های دکتری ستاد توسعه زیست فناوری </b-button
                  >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                  سامانه اقدام می نمایم
                </label>
                <b-form-checkbox
                  id="switch_1"
                  class="ml-2 mr-n2"
                  v-model="proposal.initialObligation"
                ></b-form-checkbox>
              </div>
            </b-form-group>

            <p>
              به ابزار ثبت رساله دکتری سامانه تقسیم کار ملی خوش آمدید. خواهشندیم
              ابتدا به سوالات زیر پاسخ دهید:
            </p>
            <b-form-group
              label="لطفا عنوان پیشنهادی رساله دکتری را به زبان فارسی بنویسید (حداکثر 20 کلمه)"
              :class="proposal.faSubject ? 'done' : 'required'"
            >
              <b-form-input
                trim
                type="text"
                v-model="proposal.faSubject"
              ></b-form-input>
              <b-form-group
                label="تاریخ ثبت پروپوزال"
                :class="proposal.dateProposalSubmission ? 'done' : 'required'"
                class="mt-4"
              >
                <date-picker
                  color="#7b1fa2"
                  v-model="proposal.dateProposalSubmission"
                  :editable="true"
                ></date-picker>
              </b-form-group>
              <b-form-group
                label="عنوان پایان نامه ارشد"
                :class="proposal.masterThesisSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.masterThesisSubject"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="عنوان پروژه کارشناسی (در صورت وجود) ">
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.bachelorProjectSubject"
                ></b-form-input>
              </b-form-group>
            </b-form-group>
            <b-form-group
              label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
              :class="
                proposal.initialIsSupported !== null ? 'done' : 'required'
              "
            >
              <b-form-radio-group v-model="proposal.initialIsSupported">
                <b-form-radio :value="true">بله</b-form-radio>
                <b-form-radio :value="false">خیر</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="حمایت ها:"
              v-if="proposal.initialIsSupported"
              :class="proposal.initialSupportedType ? 'done' : 'required'"
            >
              <b-form-select
                class="myselect2"
                id="first"
                v-model="proposal.initialSupportedType"
                :options="options"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="عنوان حمایت دریافتی"
              v-if="
                proposal.initialSupportedType == 'other' &&
                proposal.initialIsSupported
              "
              :class="proposal.initialOtherSupport ? 'done' : 'required'"
            >
              <b-form-input
                trim
                type="text"
                v-model="proposal.initialOtherSupport"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="توضیحات حمایت دریافتی:"
              v-if="proposal.initialIsSupported"
              :class="proposal.initialSupportDescription ? 'done' : 'required'"
            >
              <b-form-textarea
                trim
                rows="6"
                v-model="proposal.initialSupportDescription"
              >
              </b-form-textarea>
            </b-form-group>
          </b-tab>
          <b-tab :title="' اطلاعات اصلی رساله دکتری'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات اصلی رساله دکتری</h4>
              </template>
              <b-form-group label="عنوان به زبان فارسی (حداکثر 20 کلمه)">
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.faSubject"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="عنوان به زبان انگلیسی"
                :class="proposal.enSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  dir="ltr"
                  v-model="proposal.enSubject"
                  @keydown="nameKeydown($event)"
                ></b-form-input>
              </b-form-group>
              <hr />
              <b-row class="mb-2">
                <b-col>
                  <span
                    :class="
                      proposal.universityId
                        ? proposal.universityId != notUniversity
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                    >دانشگاه محل اجرای رساله دکتری</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    v-model="proposal.universityId"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="reactivity = !reactivity"
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group
                :class="
                  proposal.universityId
                    ? proposal.universityId != notUniversity
                      ? 'done'
                      : proposal.otherUniversity
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <Select2
                  v-model="proposal.universityId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @change="removeMehvar()"
                  :disabled="proposal.universityId == notUniversity"
                ></Select2>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherUniversity"
                  v-show="proposal.universityId == notUniversity"
                  placeholder="نام دانشگاه مورد نظر"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <!--Tooltip usage full here https://bootstrap-vue.org/docs/directives/tooltip ::::::::::::: v-b-tooltip.hover.left title="متن توضیحی"-->
              <b-form-group
                :disabled="!proposal.universityId"
                label="محور رساله دکتری (لطفا یک گزینه را انتخاب کنید)"
                :class="
                  proposal.mehvarId
                    ? proposal.mehvarId != notMehvar
                      ? 'done'
                      : proposal.otherMehvars
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <b-list-group>
                  <b-list-group-item
                    style="cursor: pointer"
                    v-for="(mehvar, index) in computedMehvars"
                    :variant="
                      selectedMehvar == index || !proposal.mehvarId
                        ? 'info'
                        : 'light'
                    "
                    :key="index"
                    @click="
                      proposal.mehvarId = mehvar.id;
                      selectedMehvar = index;
                    "
                    :disabled="mehvar.id == 0"
                  >
                    <span v-if="selectedMehvar == index">
                      <i class="fa fa-check-circle text-success"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-circle"></i>
                    </span>
                    {{ mehvar.text }}
                  </b-list-group-item>
                </b-list-group>
                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherMehvars"
                  v-show="proposal.mehvarId == notMehvar"
                  placeholder="نام محور مورد نظر"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="ماهیت رساله دکتری"
                :class="
                  proposal.typeStudy ||
                  proposal.typeSystemicDevelopmental ||
                  proposal.typePractical
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.typeStudy"
                  >مطالعاتی</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.typeSystemicDevelopmental"
                  >سیستمی و توسعه‌ای</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.typePractical"
                  >کاربردی</b-form-checkbox
                >
              </b-form-group>

              <b-form-group label="حوزه رساله دکتری">
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.zoneMedicine"
                  >پزشکی</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.zoneAgriculture"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.zoneEnvironment"
                  >محیط زیست</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.zoneIndustrial"
                  >صنعتی</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.zoneBioComputing"
                  >رایانش زیستی</b-form-checkbox
                >
                <b-form-checkbox
                  class="mt-3 c-dark"
                  v-model="proposal.zoneOther"
                  >سایر</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="' اطلاعات دانشجو'">
            <b-card class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات دانشجو</h4>
              </template>
              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherName ? 'done' : 'required'"
                description
                label="نام:"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherLastName ? 'done' : 'required'"
                description
                label="نام خانوادگی:"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherLastName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="
                  isIDClass(proposal.researcherNatCode) ? 'done' : 'required'
                "
                description
                label="کدملی:"
              >
                <b-form-input
                  trim
                  type="number"
                  :no-wheel="true"
                  v-model="proposal.researcherNatCode"
                  aria-describedby="input-1-live-feedback"
                  :state="isID(proposal.researcherNatCode)"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >کد ملی درست نیست</b-form-invalid-feedback
                >
              </b-form-group>
              <b-row>
                <b-col>
                  <b-form-group
                    id="fieldset-horizontal"
                    :class="proposal.researcherMobile ? 'done' : 'required'"
                    description
                    label="تلفن همراه:"
                  >
                    <b-form-input
                      trim
                      v-model="proposal.researcherMobile"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherFax ? 'done' : 'required'"
                description
                label="دورنگار:"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherFax"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="
                  isEmailClass(proposal.researcherEmail) ? 'done' : 'required'
                "
                description
                label="پست الکترونیکی:"
              >
                <b-form-input
                  trim
                  :state="isEmail(proposal.researcherEmail)"
                  aria-describedby="input-1-live-feedback"
                  v-model="proposal.researcherEmail"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >پست الکترونیکی درست نیست</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherStateId ? 'done' : 'required'"
                description
                label="استان:"
              >
                <!-- <b-form-input trim  v-model="proposal.researcherState"></b-form-input> -->
       <v-autocomplete
                  v-model="proposal.researcherStateId"
                  :items="iran"
                  @change="
                    proposal.researcherCityId = '';
                    proposal.researcherCity = '';
                    proposal.researcherState = iran.filter(
                      (x) => x.id == proposal.researcherStateId
                    )[0].name;
                    reactivity2 = !reactivity2;
                  "
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                ></v-autocomplete>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherCityId ? 'done' : 'required'"
                description
                label="شهر:"
              >
                        <span v-show="false">{{ reactivity2 }}</span>

                <v-autocomplete
                  v-model="proposal.researcherCityId"
                  :items="
                    iran
                      .filter((x) => x.id == proposal.researcherStateId)
                      .map((y) => y.cities)[0]
                  "
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                  @change="
                    reactivity2 = !reactivity2;
                    proposal.researcherCity = iran
                      .filter((x) => x.id == proposal.researcherStateId)[0]
                      .cities.filter(
                        (y) => y.id == proposal.researcherCityId
                      )[0].name;
                  "
                ></v-autocomplete>
              </b-form-group>
              <b-row class="mb-2">
                <b-col>
                  <span :class="universityClass">دانشگاه محل تحصیل:</span>
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    v-model="proposal.researcherUniversityId"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="reactivity = !reactivity"
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group
                id="fieldset-horizontal"
                :class="universityClass"
                description
              >
                <Select2
                  class="myselect2"
                  v-model="proposal.researcherUniversityId"
                  :options="universities"
                  :disabled="proposal.researcherUniversityId == notUniversity"
                  :settings="{ width: '100%' }"
                  @select="conditionalSelect($event, 'Eedu')"
                ></Select2>
                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.researcherUniversityOther"
                  v-show="proposal.researcherUniversityId == notUniversity"
                  placeholder="نام دانشگاه"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherStudentNumber ? 'done' : 'required'"
                description
                label="شماره دانشجویی:"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherStudentNumber"
                  type="number"
                  :no-wheel="true"
                ></b-form-input>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اساتید راهنما و مشاور'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اساتید راهنما و مشاور</h4>
              </template>

              <!-- NOTE (b-addprof) to add a prof to profs' list -->
              <b-button variant="primary" class="mb-3" @click="addprof()"
                >افزودن استاد جدید</b-button
              >
              <p>(تعداد اساتید رساله دکتری: {{ teachers.length }})</p>
              <hr />
              <b-card
                no-body
                v-for="(prof, index) in teachers"
                :key="index"
                class="border-0 shadow-sm"
              >
                <!-- NOTE (b-deleteprof) to remove a prof from prof list -->
                <b-button
                  style="background-color: #361780"
                  class="border-0 shadow-sm"
                  block
                  v-b-toggle="String(index)"
                >
                  <span>
                    <h5 class="text-white mt-2" style="display: inline-block">
                      استاد شماره {{ index + 1 }}
                    </h5>
                  </span>
                  <b-button
                    variant="danger"
                    @click="deleteprof(index)"
                    style="float: left"
                    >حذف استاد</b-button
                  >
                </b-button>

                <b-collapse
                  :id="String(index)"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <b-form-group
                        :class="prof.name ? 'done' : 'required'"
                        label="نام"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="prof.name"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        :class="prof.lastName ? 'done' : 'required'"
                        label="نام خانوادگی"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="prof.lastName"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        :class="prof.mobile ? 'done' : 'required'"
                        label="تلفن همراه"
                      >
                        <b-form-input
                          trim
                          type="number"
                          :no-wheel="true"
                          v-model="prof.mobile"
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        :class="isIDClass(prof.natCode) ? 'done' : 'required'"
                        label="کدملی"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="prof.natCode"
                          aria-describedby="input-1-live-feedback"
                          :state="isID(prof.natCode)"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >کد ملی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>

                      <b-form-group
                        :class="isEmailClass(prof.email) ? 'done' : 'required'"
                        label="پست الکترونیکی"
                      >
                        <b-form-input
                          trim
                          :state="isEmail(prof.email)"
                          aria-describedby="input-1-live-feedback"
                          type="text"
                          v-model="prof.email"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >پست الکترونیکی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>

                      <b-form-group
                        :class="prof.position ? 'done' : 'required'"
                        label="سمت"
                      >
                        <b-form-input
                          trim
                          v-model="prof.position"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        :class="prof.role ? 'done' : 'required'"
                        label="نقش استاد در پایان‌نامه"
                      >
                        <b-form-select
                          v-model="prof.role"
                          :options="roles"
                        ></b-form-select>
                      </b-form-group>
                      <b-row class="mb-2">
                        <b-col>
                          <span
                            :class="
                              prof.universityId
                                ? prof.universityId != notUniversity
                                  ? 'done'
                                  : prof.universityOther
                                  ? 'done'
                                  : 'required'
                                : 'required'
                            "
                            >دانشگاه محل تحصیل:</span
                          >
                        </b-col>
                        <b-col class="text-left">
                          <b-form-checkbox
                            v-model="prof.universityId"
                            :value="notUniversity"
                            unchecked-value=""
                            @change="reactivity = !reactivity"
                          >
                            سایر دانشگاه ها
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-form-group
                        :class="
                          prof.universityId
                            ? prof.universityId != notUniversity
                              ? 'done'
                              : prof.universityOther
                              ? 'done'
                              : 'required'
                            : 'required'
                        "
                      >
                        <Select2
                          v-model="prof.universityId"
                          :options="universities"
                          :settings="{ width: '100%' }"
                          :disabled="prof.universityId == notUniversity"
                          @select="conditionalSelect($event, 'Cedu')"
                        ></Select2>
                        <b-form-input
                          trim
                          class="mt-1"
                          v-model="prof.universityOther"
                          v-show="prof.universityId == notUniversity"
                          placeholder="نام دانشگاه"
                          @input="reactivity = !reactivity"
                        ></b-form-input>
                      </b-form-group>
                      <b-row class="mb-2">
                        <b-col>
                          <span
                            :class="
                              prof.universityJobId
                                ? prof.universityJobId != notUniversity
                                  ? 'done'
                                  : prof.universityJobOther
                                  ? 'done'
                                  : 'required'
                                : 'required'
                            "
                            >دانشگاه محل اشتغال:</span
                          >
                        </b-col>
                        <b-col class="text-left">
                          <b-form-checkbox
                            v-model="prof.universityJobId"
                            :value="notUniversity"
                            unchecked-value=""
                            @change="reactivity = !reactivity"
                          >
                            سایر دانشگاه ها
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-form-group
                        :class="
                          prof.universityJobId
                            ? prof.universityJobId != notUniversity
                              ? 'done'
                              : prof.universityJobOther
                              ? 'done'
                              : 'required'
                            : 'required'
                        "
                      >
                        <Select2
                          v-model="prof.universityJobId"
                          :options="universities"
                          :settings="{ width: '100%' }"
                          :disabled="prof.universityJobId == notUniversity"
                          @select="conditionalSelect($event, 'Cjob')"
                        ></Select2>
                        <b-form-input
                          trim
                          class="mt-1"
                          v-model="prof.universityJobOther"
                          v-show="prof.universityJobId == notUniversity"
                          placeholder="نام دانشگاه"
                          @input="reactivity = !reactivity"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        :class="prof.lastDegree ? 'done' : 'required'"
                        label="آخرین مدرک تحصیلی"
                      >
                        <b-form-select
                          v-model="prof.lastDegree"
                          :options="eduGradeOptions"
                          @select="conditionalSelect($event, 'Clast')"
                        ></b-form-select>
                      </b-form-group>
                      <b-form-group
                        :class="prof.resumeFileId ? 'done' : 'required'"
                        label="رزومه سوابق علمی، تخصصی،و تحقیقاتی "
                      >
                        <b-form-file
                          :state="Boolean(prof.resumeFile)"
                          :disabled="Boolean(prof.resumeFile)"
                          @input="profUploadFile(prof.file, index)"
                          v-model="prof.file"
                          browse-text="بارگذاری"
                          :placeholder="' (حداکثر ۵ مگابایت)'"
                        ></b-form-file>
                      </b-form-group>
                      <b-form-group>
                        <b-col>
                          <b-row></b-row>
                          <br />
                          <b-progress
                            class="mt-2"
                            v-if="prof.showProgress"
                            :value="prof.uploadPercentage"
                            :max="max"
                            show-progress
                            :animated="prof.striped"
                            :variant="prof.variant"
                          ></b-progress
                          ><br />
                          <b-row>
                            <b-col>
                              <b-row>
                                <div
                                  v-if="prof.isUploaded"
                                  color="green"
                                  class="mt-3"
                                  style="color: green"
                                >
                                  فایل با موفقیت بارگذاری شد.
                                </div>
                              </b-row>
                            </b-col>
                            <b-col>
                              <b-row align-h="end">
                                <span class="mt-3 ml-2" style="float: left"
                                  ><a
                                    class="btn btn-success white--text"
                                    v-if="prof.resumeFile"
                                    :href="prof.resumeFile"
                                    target="_blank"
                                    >دریافت</a
                                  ></span
                                >
                                <b-button
                                  style="height: 35px; float: left"
                                  class="btn ml-2 mt-3"
                                  v-if="prof.resumeFile"
                                  variant="danger"
                                  @click="
                                    prof.file = '';
                                    prof.resumeFile = '';
                                    prof.resumeFileId = '';
                                    prof.isUploaded = false;
                                    prof.uploadPercentage = 0;
                                  "
                                  >حذف</b-button
                                >
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-form-group>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <!-- <b-card
              v-for="(prof, index) in advisors"
              :key="prof.name"
              class="border-0 shadow-sm"
            >
              <template v-slot:header>
                <strong>استاد شماره {{index+1}}</strong>
               
              </template>

            </b-card>-->
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات پروپوزال'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات پروپوزال</h4>
              </template>

              <b-form-group
                label="بیان مساله"
                :class="proposal.problemStatement ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.problemStatement"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="ضرورت تحقیق"
                :class="proposal.requestNecessity ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.requestNecessity"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="سوالات تحقیق (اصلی/فرعی)"
                :class="proposal.researchQuestions ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.researchQuestions"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group label="فرضیات تحقیق (اصلی/فرعی)">
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.researchHypotheses"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="اهداف تحقیق (اصلی/فرعی)"
                :class="proposal.majorGoals ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.majorGoals"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="روش کلی تحقیق"
                :class="proposal.generalResearchMethod ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.generalResearchMethod"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <!-- <b-form-group
                label="قلمرو مکانی تحقیق"
                :class="proposal.spatialScopeResearch ? 'done' : 'required'"
              >
                <div class="items-box pa-4">
                  <div class="d-flex flex-row">
                    <b-form-input
                      placeholder="قلمرو مکانی تحقیق مورد نظر را وارد کنید..."
                      v-model="placeItem"
                      @keyup.enter="placeItem ? addItem() : ''"
                    >
                    </b-form-input>
                    <b-btn
                      :disabled="!placeItem"
                      class="ms-4"
                      variant="primary"
                      @click="addItem()"
                    >
                      افزودن
                    </b-btn>
                  </div>

                  <div
                    class="py-4 grey--text"
                    v-if="!proposal.spatialScopeResearch.length"
                  >
                    موردی ثبت نشده است.
                  </div>

                  <div v-else class="d-flex flex-column px-1 pt-4 mb-0">
                    <span
                      v-for="(item, index) in proposal.spatialScopeResearch"
                      :key="index"
                      class="pb-3 c-dark"
                    >
                      <span
                        @click="proposal.spatialScopeResearch.splice(index, 1)"
                        class="pointer"
                      >
                        <v-icon class="red--text me-2"
                          >mdi-close-circle-outline</v-icon
                        >
                      </span>
                      {{ item }}
                    </span>
                  </div>
                </div>
              </b-form-group> -->
              <b-form-group
                label="قلمرو مکانی تحقیق"
                :class="proposal.spatialScopeResearch ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.spatialScopeResearch"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="قلمرو زمانی تحقیق"
                :class="proposal.researchTimeDomain ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.researchTimeDomain"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="روش نمونه گیری و تعیین حجم نمونه"
                :class="proposal.researchSampling ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.researchSampling"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="روش گرد آوری داده ها و ابزار"
                :class="proposal.dataCollectionMethod ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.dataCollectionMethod"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="روش های تحلیل داده ها"
                :class="proposal.analysisMethod ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.analysisMethod"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="موانع و محدودیت های تحقیق"
                :class="proposal.researchObstacles ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.researchObstacles"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                :class="
                  proposal.researchMacroTheoreticalFramework
                    ? 'done'
                    : 'required'
                "
                label="چارچوب کلان نظری تحقیق"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.researchMacroTheoreticalFramework"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                :class="proposal.roadMapFile ? 'done' : 'required'"
                label="نقشه راه"
              >
                <b-form-file
                  :state="Boolean(proposal.roadMapFile)"
                  :disabled="Boolean(proposal.roadMapFile)"
                  @input="uploadFile(uploadedFiles[0].file, 0, 'roadMapFile')"
                  v-model="uploadedFiles[0].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[0]
                      ? files[0].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[0].uploadPercentage"
                    :value="uploadedFiles[0].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[0].striped"
                    :variant="uploadedFiles[0].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[0].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row align-h="end" v-if="proposal.roadMapFile">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.roadMapFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(0, 'roadMapFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="مدل تحقیق">
                <b-form-file
                  @input="
                    uploadFile(uploadedFiles[1].file, 1, 'researchModelFile')
                  "
                  :disabled="Boolean(proposal.researchModelFile)"
                  v-model="uploadedFiles[1].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[1]
                      ? files[1].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="Boolean(uploadedFiles[1].uploadPercentage)"
                    :value="uploadedFiles[1].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[1].striped"
                    :variant="uploadedFiles[1].variant"
                  ></b-progress
                  ><br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[1].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.researchModelFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.researchModelFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(1, 'researchModelFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="مبانی نظری"
                :class="
                  proposal.theoreticalFoundationsFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.theoreticalFoundationsFile)"
                  :disabled="Boolean(proposal.theoreticalFoundationsFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[2].file,
                      2,
                      'theoreticalFoundationsFile'
                    )
                  "
                  v-model="uploadedFiles[2].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[2]
                      ? files[2].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-form-group>
                  <b-col>
                    <b-progress
                      class="mt-2"
                      v-if="uploadedFiles[2].uploadPercentage"
                      :value="uploadedFiles[2].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[2].striped"
                      :variant="uploadedFiles[2].variant"
                    ></b-progress
                    ><br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[2].isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          v-if="proposal.theoreticalFoundationsFile"
                          align-h="end"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="proposal.theoreticalFoundationsFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(2, 'theoreticalFoundationsFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </b-form-group>
              <b-form-group
                label="پیشینه تحقیق داخلی"
                :class="
                  proposal.internalResearchBackgroundFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.internalResearchBackgroundFile)"
                  :disabled="Boolean(proposal.internalResearchBackgroundFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[3].file,
                      3,
                      'internalResearchBackgroundFile'
                    )
                  "
                  v-model="uploadedFiles[3].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[3]
                      ? files[3].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[3].uploadPercentage"
                    :value="uploadedFiles[3].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[3].striped"
                    :variant="uploadedFiles[3].variant"
                  ></b-progress
                  ><br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[3].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.internalResearchBackgroundFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.internalResearchBackgroundFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(3, 'internalResearchBackgroundFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="پیشینه تحقیق خارجی"
                :class="
                  proposal.foreignResearchBackgroundFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.foreignResearchBackgroundFile)"
                  :disabled="Boolean(proposal.foreignResearchBackgroundFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[4].file,
                      4,
                      'foreignResearchBackgroundFile'
                    )
                  "
                  v-model="uploadedFiles[4].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[4]
                      ? files[4].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[4].uploadPercentage"
                    :value="uploadedFiles[4].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[4].striped"
                    :variant="uploadedFiles[4].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[4].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.foreignResearchBackgroundFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.foreignResearchBackgroundFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(4, 'foreignResearchBackgroundFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="شرح واژه ها و اصطلاحات"
                :class="proposal.keywords ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.keywords"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="فهرست منابع"
                :class="proposal.references ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.references"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'اطلاعات تجاری‌سازی'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات تجاری‌سازی</h4>
              </template>
              <v-row
                class="p-1 mb-4 grey lighten-2"
                style="border: 1px solid #ccc; border-radius: 10px"
              >
                <v-col>
                  <p>گزینه مورد نظر را انتخاب کنید:</p>
                  <b-form-radio-group
                    v-model="proposal.commercializingType"
                    class="d-flex justify-space-between"
                  >
                    <b-form-radio value="company" class="ms-1"
                      >شرکت دانش بنیان</b-form-radio
                    >
                    <b-form-radio value="accelerator">شتاب‌دهنده</b-form-radio>
                    <b-form-radio value="none">
                      فاقد اطلاعات تجاری‌سازی هستم</b-form-radio
                    >
                  </b-form-radio-group>
                </v-col>
              </v-row>
              <div v-if="proposal.commercializingType == 'company'">
                <div class="text-left mb-6">
                  <v-btn @click="viewList('company')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شرکت‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span
                      :class="
                        proposal.companyId
                          ? proposal.companyId != notCompany
                            ? 'done'
                            : proposal.otherCompanyName
                            ? 'done'
                            : 'required'
                          : 'required'
                      "
                    >
                      نام شرکت
                    </span>
                  </v-col>
                  <v-col class="text-left">
                    <b-form-checkbox
                      v-model="proposal.companyId"
                      :value="notCompany"
                      unchecked-value=""
                      @change="reactivity = !reactivity"
                    >
                      سایر شرکت ها
                    </b-form-checkbox>
                  </v-col>
                </v-row>
                <b-form-group
                  :class="
                    proposal.companyId
                      ? proposal.companyId != notCompany
                        ? 'done'
                        : proposal.otherCompanyName
                        ? 'done'
                        : 'required'
                      : 'required'
                  "
                >
                  <Select2
                    v-model="proposal.companyId"
                    :options="companies"
                    :settings="{ width: '100%' }"
                    :disabled="proposal.companyId == notCompany"
                    @change="getCompanyInfo()"
                  ></Select2>

                  <b-form-input
                    trim
                    class="mt-1"
                    v-model="proposal.otherCompanyName"
                    v-show="proposal.companyId == notCompany"
                    placeholder="نام شرکت مورد نظر"
                    @input="reactivity = !reactivity"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شماره ثبت"
                  :class="computedTitle1 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyRegistrationNumber
                        ? proposal.companyRegistrationNumber
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyRegistrationNumber"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شناسه ملی"
                  :class="computedTitle2 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyNationalId
                        ? proposal.companyNationalId
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyNationalId"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="معرفی فناوری یا محصولات یا خدمات"
                  :class="proposal.companyProducts ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.companyProducts"
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="آدرس"
                  :class="proposal.companyAddress ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.companyAddress"
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="کد پستی"
                  :class="proposal.companyPostalCode ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="number"
                    :no-wheel="true"
                    v-model="proposal.companyPostalCode"
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شماره تماس"
                  :class="proposal.companyTel ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="number"
                    :no-wheel="true"
                    v-model="proposal.companyTel"
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  id="fieldset-horizontal"
                  :class="
                    isEmailClass(proposal.companyEmail) ? 'done' : 'required'
                  "
                  rows="6"
                  max-rows="6"
                  description
                  label="پست الکترونیکی"
                >
                  <b-form-input
                    trim
                    :state="isEmail(proposal.companyEmail)"
                    aria-describedby="input-1-live-feedback"
                    v-model="proposal.companyEmail"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback"
                    >پست الکترونیکی درست نیست</b-form-invalid-feedback
                  >
                </b-form-group>

                <b-form-group
                  label="توضیحات:"
                  :class="proposal.companyDescription ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.companyDescription"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  :class="proposal.letterCompanyFile ? 'done' : 'required'"
                >
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه شرکت دانش بنیان یا سازمان همکار</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath +
                          `/setad/private/1613477977177name_danesh_bonyan.jpg`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :state="Boolean(proposal.letterCompanyFile)"
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(uploadedFiles[5].file, 5, 'letterCompanyFile')
                    "
                    v-model="uploadedFiles[5].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[5]
                        ? files[5].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                  <b-col>
                    <b-progress
                      class="mt-2"
                      v-if="Boolean(uploadedFiles[5].uploadPercentage)"
                      :value="uploadedFiles[5].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[5].striped"
                      :variant="uploadedFiles[5].variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[5].isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row v-if="proposal.letterCompanyFile" align-h="end">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="proposal.letterCompanyFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(5, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div
                v-else-if="proposal.commercializingType == 'accelerator'"
                class="mb-4"
              >
                <div class="text-left mb-6">
                  <v-btn @click="viewList('accelerator')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شتاب‌دهنده‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span :class="proposal.acceleratorId ? 'done' : 'required'"
                      >نام شتاب‌دهنده</span
                    >
                  </v-col>
                </v-row>
                <Select2
                  v-model="proposal.acceleratorId"
                  :options="accelerators"
                  :settings="{ width: '100%' }"
                ></Select2>
                <b-form-group>
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه شرکت دانش بنیان یا سازمان همکار</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath +
                          `/setad/private/1613477977177name_danesh_bonyan.jpg`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(uploadedFiles[5].file, 5, 'letterCompanyFile')
                    "
                    v-model="uploadedFiles[5].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[5]
                        ? files[5].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                  <b-col>
                    <b-progress
                      class="mt-2"
                      v-if="Boolean(uploadedFiles[5].uploadPercentage)"
                      :value="uploadedFiles[5].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[5].striped"
                      :variant="uploadedFiles[5].variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[5].isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row v-if="proposal.letterCompanyFile" align-h="end">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="proposal.letterCompanyFile"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(5, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div v-else-if="proposal.commercializingType == 'none'">
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation1 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation2"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation2 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
            </b-card>
          </b-tab>

          <b-tab :title="' زمان‌بندی'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">خدمات، زمان‌بندی و فازبندی رساله دکتری</h4>
              </template>

              <b-form-group>
                <!-- NOTE (b-addService) to add a row to service items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addService()"
                  >+</b-button
                >

                <!-- NOTE (t-proposal.gantData) to show informations of phase scheduling, activities description and weight percentage of activity  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="serviceFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(report)="data">
                    <b-form-checkbox
                      :id="'tooltip-target-' + data.index"
                      v-model="data.item.report"
                    ></b-form-checkbox>
                    <b-tooltip
                      placement="top"
                      :show="myshow"
                      delay="100"
                      :target="'tooltip-target-' + data.index"
                      >درصورت ارائه گزارش در پایان این فاز به ستاد، انتخاب
                      نمایید</b-tooltip
                    >
                  </template>
                  <template v-slot:cell(cellColor)="data">
                    <div>
                      <ColourPicker
                        ref="colorPicker"
                        no-input
                        picker="compact"
                        :color="data.item.cellColor"
                        :value="data.item.cellColor"
                        v-model="data.item.cellColor"
                      />
                    </div>
                  </template>

                  <template v-slot:cell(operation)="data">
                    <div>
                      <!-- NOTE (b-delService) to remove a row from service items table -->
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delService(data.index)"
                      >
                        <i class="fa fa-times" />
                      </b-button>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.description"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>

                  <template v-slot:cell(percent)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.percent"
                        type="number"
                        :no-wheel="true"
                        min="0"
                        max="100"
                        :state="
                          data.item.percent >= 0 && data.item.percent <= 100
                        "
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(startDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.startDate"
                        @change="changedStartDate(data.item, data.index)"
                      ></date-picker>
                    </div>
                  </template>
                  <template v-slot:cell(dueDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.dueDate"
                        :min="computedMinDate(data.item.startDate)"
                      ></date-picker>
                    </div>
                  </template>
                </b-table>
                <hr />

                <sarmadGantt
                  :items="proposal.gantData"
                  :fields="serviceFields"
                />

                <p
                  :class="
                    proposal.gantData
                      .map((x) => x.percent)
                      .reduce((a, b) => Number(a) + Number(b), 0) == 100
                      ? 'done'
                      : 'required'
                  "
                >
                  توجه داشته باشید که مجموع درصد وزنی فعالیت باید 100 درصد باشد.
                  درصد فعلی:
                  {{
                    proposal.gantData.length == 0
                      ? 0
                      : proposal.gantData
                          .map((x) => x.percent)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                  }}
                  %
                </p>
              </b-form-group>
            </b-card>
          </b-tab>

          <b-tab :title="'فایل‌های تکمیلی'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">فایل‌ها</h4>
              </template>

              <b-form-group
                label="نامه محل اجرای رساله دکتری"
                :class="
                  proposal.letterPlaceDissertationFile ? 'done' : 'required'
                "
              >
                <b-form-file
                  :state="Boolean(proposal.letterPlaceDissertationFile)"
                  :disabled="Boolean(proposal.letterPlaceDissertationFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[6].file,
                      6,
                      'letterPlaceDissertationFile'
                    )
                  "
                  v-model="uploadedFiles[6].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[6]
                      ? files[6].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[6].uploadPercentage"
                    :value="uploadedFiles[6].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[6].striped"
                    :variant="uploadedFiles[6].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[6].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.letterPlaceDissertationFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.letterPlaceDissertationFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(6, 'letterPlaceDissertationFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                :class="proposal.minutesDefenceFile ? 'done' : 'required'"
              >
                <b-row class="mb-2" align-v="center">
                  <b-col align-self="end">
                    <h6>
                      صورت جلسه دفاع پروپوزال بصورت رسمی و با سربرگ دانشگاه
                    </h6>
                  </b-col>
                  <b-col>
                    <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                    <a
                      :href="
                        filePath +
                        `/setad/private/1613803884641sorat_jalase_tasvib_proposal.jpg`
                      "
                      class="btn btn-primary text-light"
                      target="_blank"
                      style="float: left"
                      >دانلود نمونه فایل</a
                    >
                  </b-col>
                </b-row>
                <b-form-file
                  :state="Boolean(proposal.minutesDefenceFile)"
                  :disabled="Boolean(proposal.minutesDefenceFile)"
                  @input="
                    uploadFile(uploadedFiles[7].file, 7, 'minutesDefenceFile')
                  "
                  v-model="uploadedFiles[7].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[7]
                      ? files[7].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[7].uploadPercentage"
                    :value="uploadedFiles[7].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[7].striped"
                    :variant="uploadedFiles[7].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[7].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.minutesDefenceFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.minutesDefenceFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(7, 'minutesDefenceFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="فایل پروپوزال (Word) "
                :class="proposal.proposalWordFile ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.proposalWordFile)"
                  :disabled="Boolean(proposal.proposalWordFile)"
                  accept=".doc, .docx"
                  @input="
                    uploadFile(uploadedFiles[8].file, 8, 'proposalWordFile')
                  "
                  v-model="uploadedFiles[8].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[8]
                      ? files[8].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[8].uploadPercentage"
                    :value="uploadedFiles[8].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[8].striped"
                    :variant="uploadedFiles[8].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[8].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.proposalWordFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.proposalWordFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(8, 'proposalWordFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="فایل پروپوزال (pdf) "
                :class="proposal.proposalPdfFile ? 'done' : 'required'"
              >
                <b-form-file
                  :state="Boolean(proposal.proposalPdfFile)"
                  :disabled="Boolean(proposal.proposalPdfFile)"
                  accept=".pdf"
                  @input="
                    uploadFile(uploadedFiles[9].file, 9, 'proposalPdfFile')
                  "
                  v-model="uploadedFiles[9].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[9]
                      ? files[9].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[9].uploadPercentage"
                    :value="uploadedFiles[9].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[9].striped"
                    :variant="uploadedFiles[9].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[9].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.proposalPdfFile" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.proposalPdfFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(9, 'proposalPdfFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                :class="
                  proposal.letterUniversityAccountNumberFile
                    ? 'done'
                    : 'required'
                "
              >
                <b-row class="mb-2" align-v="center">
                  <b-col align-self="end">
                    <h6>
                      ارائه نامه رسمی جهت اعلام شماره حساب محل اجرای رساله دکتری
                    </h6>
                  </b-col>
                  <b-col>
                    <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                    <a
                      :href="filePath + `/setad/private/1613290470941�*1�.jpg`"
                      class="btn btn-primary text-light"
                      target="_blank"
                      style="float: left"
                      >دانلود نمونه فایل</a
                    >
                  </b-col>
                </b-row>
                <b-form-file
                  :state="Boolean(proposal.letterUniversityAccountNumberFile)"
                  :disabled="
                    Boolean(proposal.letterUniversityAccountNumberFile)
                  "
                  @input="
                    uploadFile(
                      uploadedFiles[10].file,
                      10,
                      'letterUniversityAccountNumberFile'
                    )
                  "
                  v-model="uploadedFiles[10].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[10]
                      ? files[10].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[10].uploadPercentage"
                    :value="uploadedFiles[10].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[10].striped"
                    :variant="uploadedFiles[10].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[10].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.letterUniversityAccountNumberFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.letterUniversityAccountNumberFile"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="
                            delFile(10, 'letterUniversityAccountNumberFile')
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (1)">
                <b-form-input
                  trim
                  class="my-2"
                  type="text"
                  v-model="proposal.otherFile1Title"
                  placeholder="عنوان فایل
                  "
                ></b-form-input>
                <b-form-textarea
                  trim
                  class="my-2"
                  type="text"
                  rows="6"
                  max-rows="6"
                  v-model="proposal.otherFile1Description"
                  placeholder="توضیحات
                  "
                ></b-form-textarea>
                <b-form-file
                  @input="uploadFile(uploadedFiles[11].file, 11, 'otherFile1')"
                  v-model="uploadedFiles[11].file"
                  :disabled="Boolean(proposal.otherFile1)"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[11]
                      ? files[11].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[11].uploadPercentage"
                    :value="uploadedFiles[11].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[11].striped"
                    :variant="uploadedFiles[11].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[11].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile1" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.otherFile1"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(11, 'otherFile1')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (2)">
                <b-form-input
                  trim
                  class="my-2"
                  type="text"
                  v-model="proposal.otherFile2Title"
                  placeholder="عنوان فایل
                  "
                ></b-form-input>
                <b-form-textarea
                  trim
                  class="my-2"
                  type="text"
                  rows="6"
                  max-rows="6"
                  v-model="proposal.otherFile2Description"
                  placeholder=" توضیحات
                  "
                ></b-form-textarea>
                <b-form-file
                  @input="uploadFile(uploadedFiles[12].file, 12, 'otherFile2')"
                  :disabled="Boolean(proposal.otherFile2)"
                  v-model="uploadedFiles[12].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[12]
                      ? files[12].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[12].uploadPercentage"
                    :value="uploadedFiles[12].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[12].striped"
                    :variant="uploadedFiles[12].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[12].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile2" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.otherFile2"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(12, 'otherFile2')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <b-form-group label="سایر مدارک (3)">
                <b-form-input
                  trim
                  class="my-2"
                  type="text"
                  v-model="proposal.otherFile3Title"
                  placeholder="عنوان فایل
                  "
                ></b-form-input>
                <b-form-textarea
                  trim
                  class="my-2"
                  type="text"
                  rows="6"
                  max-rows="6"
                  v-model="proposal.otherFile3Description"
                  placeholder="توضیحات
                  "
                ></b-form-textarea>
                <b-form-file
                  @input="uploadFile(uploadedFiles[13].file, 13, 'otherFile3')"
                  :disabled="Boolean(proposal.otherFile3)"
                  v-model="uploadedFiles[13].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[13]
                      ? files[13].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
                <b-col>
                  <b-progress
                    class="mt-2"
                    v-if="uploadedFiles[13].uploadPercentage"
                    :value="uploadedFiles[13].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[13].striped"
                    :variant="uploadedFiles[13].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[13].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile3" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.otherFile3"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(13, 'otherFile3')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <!-- NOTE (t-fileFields) to show uploded files and each file is downloadable  -->

              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="fileFields"
                :items="files.filter((x) => x && x.url != '')"
                empty-text="فایلی وجود ندارد"
                striped
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(url)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                    <a
                      v-if="data.value"
                      class="btn btn-success white--text"
                      :href="data.value"
                      target="_blank"
                      >دریافت فایل</a
                    >
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab :title="'تعهدات'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>

              <!-- <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <h4 class="mb-0">&nbsp;</h4>-->

              <b-form-group>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                  >درج عبارت زیر در رساله و کلیه انتشارات،مقالات،سخنرانی
                  ها،اسلایدها و مانند آن انجام خواهد گرفت<br />
                  '' این پژوهش با کمک مالی شماره ....... ستاد توسعه زیست فناوری
                  انجام شده است''<br />
                  ''This study was financially supported bygrant NO:.... of the
                  Biotechnology Development Council of the Islamic Republic of
                  Iran''<br />
                  در صورت عدم درج،حمایت مرحله دوم صورت نخواهد گرفت.
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                  >توافق بین دانشجو و صنعت برای بهره برداری از نتایج رساله وجود
                  دارد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >نحوه تجاری سازی رساله مشخص است و مستندات ارائه شده
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >فایل نهایی رساله،دستاوردها،ثبت اختراعات و مقالات پس از اتمام
                  رساله بارگذاری می شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >دعوتنامه جهت حضور در جلسه دفاع به حضور کارشناس گروه پژوهش
                  خواهد رسید.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                  >ثبت اطلاعات تعهدی برای حمایت نداشته و به منزله ثبت درخواست
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >پذیرفته شدن در بخش اول تعهدی برای حمایت از بخش دوم ایجاد نمی
                  کند و مدارک و اقدامات مربوط به بخش دوم در سامانه قابل ثبت و
                  بررسی خواهد بود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >کلیه موارد فوق مورد تایید اینجانب
                  {{
                    proposal.researcherName + " " + proposal.researcherLastName
                  }}
                  می باشد.</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>

          <b-tab :title="'مرور نهایی و ارسال رساله دکتری'">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-1 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    عنوان و حمایت‌های پیشین&nbsp;
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 0"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان رساله دکتری:</b> {{ proposal.faSubject }}
                      </li>

                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>تاریخ ثبت پروپوزال:</b>
                        {{ proposal.dateProposalSubmission }}
                      </li>
                      <li
                        :class="
                          proposal.masterThesisSubject ? 'done' : 'required'
                        "
                      >
                        <b>عنوان پایان‌نامه ارشد:</b>
                        {{ proposal.masterThesisSubject }}
                      </li>

                      <li>
                        <b>عنوان پروژه کارشناسی (در صورت وجود):</b>
                        {{
                          proposal.bachelorProjectSubject
                            ? proposal.bachelorProjectSubject
                            : "فاقد پروژه کارشناسی"
                        }}
                      </li>

                      <li class="done">
                        <b
                          >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                          استفاده کرده است؟</b
                        >
                        <b-form-radio-group
                          v-model="proposal.initialIsSupported"
                          disabled
                        >
                          <b-form-radio :value="true">بله</b-form-radio>
                          <b-form-radio :value="false">خیر</b-form-radio>
                        </b-form-radio-group>
                      </li>

                      <li
                        v-if="
                          proposal.initialIsSupported &&
                          proposal.initialSupportedType
                        "
                        :class="
                          proposal.initialSupportedType ? 'done' : 'required'
                        "
                      >
                        <b>حمایت ها:</b>
                        {{
                          options.filter(
                            (x) => x.value == proposal.initialSupportedType
                          )[0].text
                        }}
                      </li>
                      <li
                        v-if="
                          proposal.initialSupportedType == 'other' &&
                          proposal.initialIsSupported
                        "
                        :class="
                          proposal.initialOtherSupport ? 'done' : 'required'
                        "
                      >
                        <b> عنوان حمایت دریافتی:</b>
                        {{ proposal.initialOtherSupport }}
                      </li>
                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportDescription
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>توضیحات حمایت دریافتی:</b>
                        {{ proposal.initialSupportDescription }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات اصلی رساله دکتری
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>
                      <li :class="proposal.enSubject ? 'done' : 'required'">
                        <b>عنوان به زبان انگلیسی:</b> {{ proposal.enSubject }}
                      </li>
                      <li :class="proposal.universityId ? 'done' : 'required'">
                        <b>دانشگاه محل اجرای رساله دکتری :</b>
                        {{
                          proposal.universityId
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.universityId == notUniversity"
                        :class="proposal.otherUniversity ? 'done' : 'required'"
                      >
                        <b>نام دانشگاه:</b> {{ proposal.otherUniversity }}
                      </li>
                      <li
                        v-if="proposal.mehvarId != notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور رساله دکتری :</b>
                        {{
                          proposal.mehvarId
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور رساله دکتری :</b> سایر محورها
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.otherMehvars ? 'done' : 'required'"
                      >
                        <b>نام محور:</b> {{ proposal.otherMehvars }}
                      </li>
                      <li
                        :class="
                          proposal.typeStudy ||
                          proposal.typeSystemicDevelopmental ||
                          proposal.typePractical
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>ماهیت رساله دکتری :</b>
                        <b-form-group
                          disabled
                          :class="
                            proposal.typeStudy ||
                            proposal.typeSystemicDevelopmental ||
                            proposal.typePractical
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-form-checkbox v-model="proposal.typeStudy"
                            >مطالعاتی</b-form-checkbox
                          >
                          <b-form-checkbox
                            v-model="proposal.typeSystemicDevelopmental"
                            >سیستمی و توسعه‌ای</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.typePractical"
                            >کاربردی</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                      <li
                        :class="
                          proposal.zoneMedicine ||
                          proposal.zoneAgriculture ||
                          proposal.zoneEnvironment ||
                          proposal.zoneIndustrial ||
                          proposal.zoneBioComputing ||
                          proposal.zoneOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه رساله دکتری :</b>
                        <b-form-group disabled>
                          <b-form-checkbox v-model="proposal.zoneMedicine"
                            >پزشکی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneEnvironment"
                            >محیط زیست</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneIndustrial"
                            >صنعتی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneBioComputing"
                            >رایانش زیستی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneOther"
                            >سایر</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات دانشجو
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b>نام:</b> {{ proposal.researcherName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b>نام خانوادگی:</b> {{ proposal.researcherLastName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherNatCode ? 'done' : 'required'
                        "
                      >
                        <b>کدملی:</b> {{ proposal.researcherNatCode }}
                      </li>
                      <li
                        :class="proposal.researcherMobile ? 'done' : 'required'"
                      >
                        <b>تلفن همراه:</b> {{ proposal.researcherMobile }}
                      </li>
                      <li :class="proposal.researcherFax ? 'done' : 'required'">
                        <b>دورنگار:</b> {{ proposal.researcherFax }}
                      </li>
                      <li
                        :class="proposal.researcherEmail ? 'done' : 'required'"
                      >
                        <b>پست الکترونیکی:</b> {{ proposal.researcherEmail }}
                      </li>
                      <li
                        :class="proposal.researcherStateId ? 'done' : 'required'"
                      >
                        <b>استان:</b>  {{
                          proposal.researcherState
                            ? proposal.researcherState
                            : "-"
                        }}
                      </li>
                      <li
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                      >
                        <b>شهر:</b>    {{
                          proposal.researcherCity
                            ? proposal.researcherCity
                            : "-"
                        }}
                      </li>
                      <li
                        :class="
                          proposal.researcherUniversityId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{
                          universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          ).length
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.researcherUniversityId == notUniversity"
                        :class="
                          proposal.researcherUniversityOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ proposal.researcherUniversityOther }}
                      </li>
                      <li
                        :class="
                          proposal.researcherStudentNumber ? 'done' : 'required'
                        "
                      >
                        <b> شماره دانشجویی:</b>
                        {{ proposal.researcherStudentNumber }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    اساتید رساله دکتری
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    تعداد اساتید رساله دکتری :
                    {{ teachers.length }}
                    <b-card
                      class="mt-3 border-0 shadow-sm"
                      header-border-variant="white"
                      header-bg-variant="info"
                      v-for="(prof, index) in teachers"
                      :key="prof.name"
                    >
                      <template v-slot:header>
                        <strong>استاد شماره {{ index + 1 }}</strong>
                      </template>
                      <ul>
                        <li :class="prof.name ? 'done' : 'required'">
                          <b>نام:</b> {{ prof.name }}
                        </li>
                        <li :class="prof.lastName ? 'done' : 'required'">
                          <b>نام خانوادگی:</b> {{ prof.lastName }}
                        </li>
                        <li :class="prof.natCode ? 'done' : 'required'">
                          <b>کدملی:</b> {{ prof.natCode }}
                        </li>
                        <li :class="prof.role ? 'done' : 'required'">
                          <b>نقش استاد در پایان‌نامه:</b>
                          {{ prof.role == "supervisor" ? "مشاور" : "راهنما" }}
                        </li>
                        <li :class="prof.mobile ? 'done' : 'required'">
                          <b>تلفن همراه:</b> {{ prof.mobile }}
                        </li>
                        <li :class="prof.email ? 'done' : 'required'">
                          <b>پست الکترونیکی:</b> {{ prof.email }}
                        </li>
                        <li :class="prof.position ? 'done' : 'required'">
                          <b>سمت:</b> {{ prof.position }}
                        </li>
                        <li :class="prof.universityId ? 'done' : 'required'">
                          <b>دانشگاه محل تحصیل:</b>
                          {{
                            universities.filter(
                              (x) => x.id == prof.universityId
                            ).length
                              ? universities.filter(
                                  (x) => x.id == prof.universityId
                                )[0].text
                              : ""
                          }}
                        </li>
                        <li
                          v-if="prof.universityId == notUniversity"
                          :class="prof.universityOther ? 'done' : 'required'"
                        >
                          <b>نام دانشگاه:</b> {{ prof.universityOther }}
                        </li>
                        <li :class="prof.universityJobId ? 'done' : 'required'">
                          <b>دانشگاه محل اشتغال به عنوان عضوهئیت علمی:</b>
                          {{
                            universities.filter(
                              (x) => x.id == prof.universityJobId
                            ).length
                              ? universities.filter(
                                  (x) => x.id == prof.universityJobId
                                )[0].text
                              : ""
                          }}
                        </li>
                        <li
                          v-if="prof.universityJobId == notUniversity"
                          :class="prof.universityJobOther ? 'done' : 'required'"
                        >
                          <b>نام دانشگاه:</b> {{ prof.universityJobOther }}
                        </li>
                        <li :class="prof.lastDegree ? 'done' : 'required'">
                          <b>آخرین مدرک تحصیلی:</b> {{ prof.lastDegree }}
                        </li>
                        <li :class="prof.resumeFile ? 'done' : 'required'">
                          <b>رزومه استاد:</b>
                          <a
                            v-if="prof.resumeFile"
                            :href="prof.resumeFile"
                            target="blank"
                            >دانلود</a
                          >
                          <span v-else>--</span>
                        </li>
                      </ul>
                    </b-card>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    اطلاعات پروپوزال
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li
                        :class="proposal.problemStatement ? 'done' : 'required'"
                      >
                        <b>بیان مساله:</b> {{ proposal.problemStatement }}
                      </li>
                      <li
                        :class="proposal.requestNecessity ? 'done' : 'required'"
                      >
                        <b>ضرورت تحقیق:</b> {{ proposal.requestNecessity }}
                      </li>
                      <li
                        :class="
                          proposal.researchQuestions ? 'done' : 'required'
                        "
                      >
                        <b>سوالات تحقیق (اصلی/فرعی):</b>
                        {{ proposal.researchQuestions }}
                      </li>
                      <li>
                        <b>فرضیات تحقیق (اصلی/فرعی):</b>
                        {{
                          proposal.researchHypotheses
                            ? proposal.researchHypotheses
                            : "-"
                        }}
                      </li>
                      <li :class="proposal.majorGoals ? 'done' : 'required'">
                        <b>اهداف تحقیق(اصلی/فرعی):</b>
                        {{ proposal.majorGoals }}
                      </li>
                      <li
                        :class="
                          proposal.generalResearchMethod ? 'done' : 'required'
                        "
                      >
                        <b>روش کلی تحقیق:</b>
                        {{ proposal.generalResearchMethod }}
                      </li>
                      <li
                        :class="
                          proposal.spatialScopeResearch ? 'done' : 'required'
                        "
                      >
                        <b>قلمرو مکانی تحقیق:</b>
                        {{ proposal.spatialScopeResearch }}
                      </li>
                      <li
                        :class="
                          proposal.researchTimeDomain ? 'done' : 'required'
                        "
                      >
                        <b>قلمرو زمانی تحقیق:</b>
                        {{ proposal.researchTimeDomain }}
                      </li>
                      <li
                        :class="proposal.researchSampling ? 'done' : 'required'"
                      >
                        <b>روش نمونه گیری و تعیین حجم نمونه:</b>
                        {{ proposal.researchSampling }}
                      </li>
                      <li
                        :class="
                          proposal.dataCollectionMethod ? 'done' : 'required'
                        "
                      >
                        <b>روش گرد آوری داده ها و ابزار:</b>
                        {{ proposal.dataCollectionMethod }}
                      </li>
                      <li
                        :class="proposal.analysisMethod ? 'done' : 'required'"
                      >
                        <b>روش های تحلیل داده ها:</b>
                        {{ proposal.analysisMethod }}
                      </li>
                      <li
                        :class="
                          proposal.researchObstacles ? 'done' : 'required'
                        "
                      >
                        <b>موانع و محدودیت های تحقیق:</b>
                        {{ proposal.researchObstacles }}
                      </li>
                      <li
                        :class="
                          proposal.researchMacroTheoreticalFramework
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>چارچوب کلان نظری تحقیق:</b>
                        {{ proposal.researchMacroTheoreticalFramework }}
                      </li>
                      <!-- <li :class="uploadedFiles[1] ? 'done' : 'required'">
                      نقشه راه:
                      <a
                        v-if="uploadedFiles[1]"
                        class="btn btn-primary text-light rounded-circle"
                        :href="uploadedFiles[1].url"
                        target="_blank"
                      >
                        <b-icon
                          icon="cloud-download"
                          aria-hidden="true"
                        ></b-icon>
                      </a>
                    </li>
                    <li :class="uploadedFiles[2] ? 'done' : 'required'">
                      مدل تحقیق:
                      <a
                        v-if="uploadedFiles[2]"
                        class="btn btn-primary text-light rounded-circle"
                        :href="uploadedFiles[2].url"
                        target="_blank"
                      >
                        <b-icon
                          icon="cloud-download"
                          aria-hidden="true"
                        ></b-icon>
                      </a>
                    </li>

                    <li :class="uploadedFiles[3] ? 'done' : 'required'">
                      مبانی نظری:
                      <a
                        v-if="uploadedFiles[3]"
                        class="btn btn-primary text-light rounded-circle"
                        :href="uploadedFiles[3].url"
                        target="_blank"
                      >
                        <b-icon
                          icon="cloud-download"
                          aria-hidden="true"
                        ></b-icon>
                      </a>
                    </li>
                    <li :class="uploadedFiles[4] ? 'done' : 'required'">
                      پیشینه تحقیق داخلی:
                      <a
                        v-if="uploadedFiles[4]"
                        class="btn btn-primary text-light rounded-circle"
                        :href="uploadedFiles[4].url"
                        target="_blank"
                      >
                        <b-icon
                          icon="cloud-download"
                          aria-hidden="true"
                        ></b-icon>
                      </a>
                    </li>
                    <li :class="uploadedFiles[5] ? 'done' : 'required'">
                      پیشینه تحقیق خارجی:
                      <a
                        v-if="uploadedFiles[5]"
                        class="btn btn-primary text-light rounded-circle"
                        :href="uploadedFiles[5].url"
                        target="_blank"
                      >
                        <b-icon
                          icon="cloud-download"
                          aria-hidden="true"
                        ></b-icon>
                      </a>
                    </li> -->
                      <li :class="proposal.keywords ? 'done' : 'required'">
                        <b>شرح واژه ها و اصطلاحات:</b> {{ proposal.keywords }}
                      </li>
                      <li :class="proposal.references ? 'done' : 'required'">
                        <b>فهرست منابع:</b> {{ proposal.references }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات تجاری‌سازی
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="p-3 shadow">
                    <h4 class="mb-6">
                      نوع تجاری‌سازی:
                      {{
                        proposal.commercializingType == "company"
                          ? "شرکت دانش بنیان"
                          : proposal.commercializingType == "accelerator"
                          ? "شتاب‌دهنده"
                          : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                      }}
                    </h4>
                    <div v-if="proposal.commercializingType == 'company'">
                      <ul>
                        <div v-if="proposal.companyId != notCompany">
                          <li
                            :class="proposal.companyName ? 'done' : 'required'"
                          >
                            <b>نام شرکت دانش بنیان:</b>
                            {{ proposal.companyName }}
                          </li>
                          <li
                            :class="
                              proposal.companyRegistrationNumber
                                ? 'done'
                                : 'required'
                            "
                          >
                            <b>شماره ثبت:</b>
                            {{
                              proposal.companyRegistrationNumber
                                ? proposal.companyRegistrationNumber
                                : "-"
                            }}
                          </li>
                          <li
                            :class="
                              proposal.companyNationalId ? 'done' : 'required'
                            "
                          >
                            <b>شناسه ملی:</b>
                            {{
                              proposal.companyNationalId
                                ? proposal.companyNationalId
                                : "-"
                            }}
                          </li>
                        </div>
                        <div v-else>
                          <li
                            :class="
                              proposal.otherCompanyName ? 'done' : 'required'
                            "
                          >
                            <b>نام شرکت دانش بنیان:</b>
                            {{ proposal.otherCompanyName }}
                          </li>
                          <li
                            :class="
                              proposal.otherCompanyRegistrationNumber
                                ? 'done'
                                : 'required'
                            "
                          >
                            <b>شماره ثبت:</b>
                            {{ proposal.otherCompanyRegistrationNumber }}
                          </li>
                          <li
                            :class="
                              proposal.otherCompanyNationalId
                                ? 'done'
                                : 'required'
                            "
                          >
                            <b>شناسه ملی:</b>
                            {{ proposal.otherCompanyNationalId }}
                          </li>
                        </div>
                        <li
                          :class="
                            proposal.companyProducts ? 'done' : 'required'
                          "
                        >
                          <b> معرفی فناوری یا محصولات یا خدمات:</b>
                          {{ proposal.companyProducts }}
                        </li>
                        <li
                          :class="proposal.companyAddress ? 'done' : 'required'"
                        >
                          <b> آدرس:</b> {{ proposal.companyAddress }}
                        </li>
                        <li
                          :class="
                            proposal.companyPostalCode ? 'done' : 'required'
                          "
                        >
                          <b>کد پستی:</b> {{ proposal.companyPostalCode }}
                        </li>
                        <li :class="proposal.companyTel ? 'done' : 'required'">
                          <b> شماره تماس:</b> {{ proposal.companyTel }}
                        </li>
                        <li
                          :class="proposal.companyEmail ? 'done' : 'required'"
                        >
                          <b> پست الکترونیکی:</b> {{ proposal.companyEmail }}
                        </li>
                        <li
                          :class="
                            proposal.companyDescription ? 'done' : 'required'
                          "
                        >
                          <b>توضیحات:</b> {{ proposal.companyDescription }}
                        </li>
                      </ul>
                    </div>
                    <div
                      v-if="proposal.commercializingType == 'accelerator'"
                      :class="proposal.acceleratorId ? 'done' : 'required'"
                    >
                      <b> نام شتاب‌دهنده:</b>
                      {{
                        proposal.acceleratorId
                          ? accelerators.filter(
                              (x) => x.id == proposal.acceleratorId
                            )[0].text
                          : ""
                      }}
                    </div>
                    <ul v-if="proposal.commercializingType == 'none'">
                      <li
                        class="mb-4 d-flex flex-row"
                        :class="
                          proposal.commercializingObligation1
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-checkbox
                          v-model="proposal.commercializingObligation1"
                          disabled
                          class="me-4"
                        ></b-form-checkbox>
                        تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست
                        توسط یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه
                        زیست فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد
                        داشت.
                      </li>
                      <li
                        class="d-flex flex-row"
                        :class="
                          proposal.commercializingObligation2
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-checkbox
                          v-model="proposal.commercializingObligation2"
                          disabled
                          class="me-4"
                        ></b-form-checkbox>
                        تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و
                        علمی این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های
                        مجاز قرار خواهد گرفت تا بتوانند با بررسی اطلاعات،
                        درخواست بنده را بررسی و تایید کنند.
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-7 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    زمان‌بندی و فازبندی انجام رساله دکتری
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-7"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b>زمان شروع:</b>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.min(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.startDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    <b>زمان پایان:</b>
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.max(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    <b>مدت زمان:</b>
                    {{
                      proposal.gantData.length > 0
                        ? (Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          ) -
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )) /
                            3600 /
                            24 /
                            1000 +
                          " روز"
                        : ""
                    }}
                    <br />
                    <br />
                    <div>
                      <sarmadGantt
                        :items="proposal.gantData"
                        :fields="serviceFields"
                      />
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-8 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    فایل‌های تکمیلی&nbsp;
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 7"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-8"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <h5>
                      در این جدول کلیه فایل‌های رساله را مشاهده میفرمایید.
                    </h5>
                    <b-table
                      responsive
                      show-empty
                      head-variant="dark"
                      :fields="fileFields"
                      :items="files.filter((x) => x && x.url != '')"
                      empty-text="فایلی وجود ندارد"
                      striped
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>

                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(url)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                          <a
                            v-if="data.value"
                            class="btn btn-success white--text"
                            :href="data.value"
                            target="_blank"
                            >دریافت فایل</a
                          >
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong>در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-9 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 8"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-9"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group disabled>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[0]"
                        >درج عبارت زیر در رساله و کلیه انتشارات،مقالات،سخنرانی
                        ها،اسلایدها و مانند آن انجام خواهد گرفت<br />
                        '' این پژوهش با کمک مالی شماره ....... ستاد توسعه زیست
                        فناوری انجام شده است''<br />
                        ''This study was financially supported bygrant NO:....
                        of the Biotechnology Development Council of the Islamic
                        Republic of Iran''<br />
                        در صورت عدم درج،حمایت مرحله دوم صورت نخواهد گرفت.
                      </b-form-checkbox>
                      <b-form-checkbox
                        :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[1]"
                        >توافق بین دانشجو و صنعت برای بهره برداری از نتایج رساله
                        وجود دارد.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[2]"
                        >نحوه تجاری سازی رساله مشخص است و مستندات ارائه شده
                        است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[3]"
                        >فایل نهایی رساله،دستاوردها،ثبت اختراعات و مقالات پس از
                        اتمام رساله بارگذاری می شود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[4]"
                        >دعوتنامه جهت حضور در جلسه دفاع به حضور کارشناس گروه
                        پژوهش خواهد رسید.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[5]"
                        >ثبت اطلاعات تعهدی برای حمایت نداشته و به منزله ثبت
                        درخواست است.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[6]"
                        >پذیرفته شدن در بخش اول تعهدی برای حمایت از بخش دوم
                        ایجاد نمی کند و مدارک و اقدامات مربوط به بخش دوم در
                        سامانه قابل ثبت و بررسی خواهد بود.</b-form-checkbox
                      >
                      <b-form-checkbox
                        :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                        v-model="proposal.promiseArrays[7]"
                        >کلیه موارد فوق مورد تایید اینجانب
                        {{
                          proposal.researcherName +
                          " " +
                          proposal.researcherLastName
                        }}
                        می باشد.</b-form-checkbox
                      >
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- NOTE (b-submitProposal) to submit proposal -->
            <!-- :disabled="lastStepProgress != 100" -->
            <b-button class="m-2" variant="success" @click="submitProposal()"
              >ارسال</b-button
            >
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3 pt-4">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >
          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 9"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <!-- <b-modal
      id="modal"
      ref="delReviewer"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center"
      size="md"
    >
      <template v-slot:modal-header>
        <h4>حذف داور رساله دکتری</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <b-button variant="danger" size="lg" @click="doDeleteReviewer()">حذف کن</b-button>

            <b-button variant="warning" size="lg" class="ml-2" @click="hideModal('delReviewer')">لغو</b-button>
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      ایا از حذف این داور مطمئن هستید؟
      <br />
      <br />این کار غیر قابل برگشت خواهد بود!
    </b-modal>-->
      <b-modal
        id="modal"
        ref="delprof"
        header-bg-variant="primary"
        header-text-variant="white"
        class="text-center"
        size="md"
      >
        <template v-slot:modal-header>
          <h4>حذف استاد</h4>
        </template>
        <template v-slot:modal-footer>
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <!-- NOTE (b-doDeleteprof) to confirm the prof removal -->
              <b-button variant="danger" size="lg" @click="doDeleteprof()"
                >حذف کن</b-button
              >

              <!-- NOTE (b-doDeleteprof) to cancel the prof removal -->
              <b-button
                variant="warning"
                size="lg"
                class="ml-2"
                @click="hideModal('delprof')"
                >لغو</b-button
              >
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </template>
        ایا از حذف این استاد مطمئن هستید؟
        <br />
        <br />این کار غیر قابل برگشت خواهد بود!
      </b-modal>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & researchTimeDomain
const sarmadGantt = () => import("../../components/sarmadGantt");
import { Compact } from "vue-color"; // REVIEW
import ColourPicker from "vue-colour-picker"; // REVIEW
import mixin from "../../mixins/utilities";

export default {
  mixins: [mixin],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    compact: Compact,
    ColourPicker,
  },
  data() {
    return {
      isLoaded: true,
      loaded: false,
      reactivity: true,
      reactivity2: true,
      researchers: [],
      descriptionTemplates: [
        { title: "", description: "" },
        { title: "", description: "نقشه راه" },
        { title: "", description: "مدل تحقیق" },
        { title: "", description: "مبانی نظری" },
        { title: "", description: "پیشینه تحقیق داخلی" },
        { title: "", description: "پیشینه تحقیق خارجی" },
        { title: "", description: "نامه محل اجرای رساله دکتری" },
        {
          title: "",
          description: "صورت جلسه دفاع پروپوزال بصورت رسمی و با سربرگ دانشگاه",
        },
        { title: "", description: "فایل پروپوزال (Word)" },
        { title: "", description: "فایل پروپوزال (pdf)" },
        {
          title: "",
          description:
            "ارائه نامه رسمی جهت اعلام شماره حساب محل اجرای رساله دکتری",
        },
        { title: "", description: "نامه شرکت دانش بنیان یا سازمان همکار" },
        { title: "", description: "" },
        { title: "", description: "" },
        { title: "", description: "" },
      ],
      pageLoaded: false,

      selectedMehvar: 0,
      infoo: "",

      moment: moment,
      show: false,
      roles: [
        { text: "استاد مشاور", value: "supervisor" },
        { text: "استاد راهنما", value: "advisor" },
      ],
      config: {
        locale: {
          name: "en",
        },

        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          researchTimeDomain: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      supportedType: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      universities: [],
      max: 100,

      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      fileTitles: [
        "نقشه راه",
        "مدل تحقیق",
        "مبانی نظری",
        "پیشینه تحقیق داخلی",
        "پیشینه تحقیق خارجی",
        "نامه شرکت دانش بنیان یا سازمان همکار",
        "نامه محل اجرای رساله دکتری",
        "صورت جلسه دفاع پروپوزال بصورت رسمی و با سربرگ دانشگاه",
        "فایل پروپوزال (Word)",
        "فایل پروپوزال (pdf)",
        "ارائه نامه رسمی جهت اعلام شماره حساب محل اجرای رساله دکتری",
        "سایر مدارک (1)",
        "سایر مدارک (2)",
        "سایر مدارک (3)",
      ],

      source: "",
      specs: {},
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
        { key: "operation", label: "" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      perPrices: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "ریال",
          text: "ریال",
        },
      ],
      options1: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      options2: [
        {
          value: "تمام وقت",
          text: "تمام وقت",
        },
        {
          value: "پاره وقت",
          text: "پاره وقت",
        },
      ],
      sources: [
        {
          value: "داخلی",
          text: "داخلی",
        },
        {
          value: "خارجی",
          text: "خارجی",
        },
      ],
      selectedprof: "",
      executor: {},
      iran: [],
      proposal: {
        initialIsSupported: null,
        gantData: [],
        promiseArrays: [],
        teachers: [],
        researcherId: 0,
        commercializingType: "company",
        letterPlaceDissertationFile: "",
        minutesDefenceFile: "",
        proposalWordFile: "",
        proposalPdfFile: "",
        letterUniversityAccountNumberFile: "",
        letterCompanyFile: "",
        otherFile1: "",
        otherFile2: "",
        otherFile3: "",
      },
      sending: false,
      researchers: [],
      placeItem: "",
      teachers: [],
      advisors: [],
      prof: {},
      eduGradeOptions: [
        { text: "--مقطع را انتخاب کنید", disabled: true },
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      mehvars: [],
      companies: [],
      accelerators: [],
      achievmentitems: [],
      // reviewerData: [],
      additionalFiles: {
        zero: { uploadPercentage: 0 },
        roadMap: { uploadPercentage: 0 },
        researchModel: { uploadPercentage: 0 },
        mabaniNazari: { uploadPercentage: 0 },
        tahghighDakheli: { uploadPercentage: 0 },
        tahghighKhreji: { uploadPercentage: 0 },
        nameEjraTez: { uploadPercentage: 0 },
        sooratJalase: { uploadPercentage: 0 },
        wordProposalFile: { uploadPercentage: 0 },
        pdfProposalFile: { uploadPercentage: 0 },
        NameShomareHesab: { uploadPercentage: 0 },
        NameDanesh: { uploadPercentage: 0 },
        sayerMadarek: { uploadPercentage: 0 },
        sayerMadarek2: { uploadPercentage: 0 },
        sayerMadarek3: { uploadPercentage: 0 },
      },
      uploadedFiles: new Array(14).fill({
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      }),
      files: [
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
        {
          showName: "",
          url: "",
          id: "",
        },
      ],

      isSaving: false,
      selectedReviewer: {},
      color: "",
      tabIndex: 1,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      showTop: false,
      gettingMobile: false,
    };
  },

  methods: {
    viewList(type) {
      localStorage.setItem("list", type);
      let link = "/map";
      window.open(link, "_blank");
    },
    showAcount() {
      this.$http
        .post(
          this.baseUrl + "/setad/admin/researcher/getInfo",
          {
            researcherId: this.proposal.researcherId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal.researcherName = "";
          this.proposal.researcherLastName = "";
          this.proposal.researcherNatCode = "";
          this.proposal.researcherMobile = "";
          this.proposal.researcherFax = "";
          this.proposal.researcherEmail = "";
          this.proposal.researcherState = "";
          this.proposal.researcherCity = "";
          this.proposal.researcherStateId = "";
          this.proposal.researcherCityId = "";
          this.proposal.researcherUniversityId = "";
          this.proposal.researcherUniversityJobId = "";
          this.proposal.researcherLastDegree = "";
          //////////////////////////////////////////
          this.executor = res.data.researcher;
          this.proposal.researcherName = this.executor.name;
          this.proposal.researcherLastName = this.executor.lastName;
          this.proposal.researcherNatCode = this.executor.natCode;
          this.proposal.researcherMobile = this.executor.mobile;
          this.proposal.researcherFax = this.executor.fax;
          this.proposal.researcherEmail = this.executor.email;
          this.proposal.researcherState = this.executor.state;
          this.proposal.researcherCity = this.executor.city;
          this.proposal.researcherStateId = this.executor.stateId;
          this.proposal.researcherCityId = this.executor.cityId;
          this.proposal.researcherUniversityId = this.executor.universityId;
          this.proposal.researcherUniversityJobId =
            this.executor.universityJobId;
          this.proposal.researcherLastDegree = this.executor.lastDegree;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCompanyInfo() {
      if (this.proposal.companyId != this.notCompany) {
        this.proposal.companyName = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].name;
        this.proposal.companyRegistrationNumber = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].registrationNumber;
        this.proposal.companyNationalId = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].nationalId;
      }
    },
    // changeCompany() {
    //   if (
    //     !this.proposal.companyId ||
    //     this.proposal.companyId == this.notCompany
    //   ) {
    //     this.proposal.otherCompanyName = "";
    //     this.proposal.otherCompanyRegistrationNumber = "";
    //     this.proposal.otherCompanyNationalId = "";
    //   }
    // },
    removeMehvar() {
      this.proposal.mehvarId = "";
      this.proposal.otherMehvars = "";
    },
    nameKeydown(e) {
      if (/[^a-zA-Z 0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    changedStartDate(data, index) {
      if (
        moment(data.startDate, "jYYYY/jM/JD").format("X") >
        moment(data.dueDate, "jYYYY/jM/JD").format("X")
      ) {
        this.proposal.gantData[index].dueDate = this.computedMinDate(
          data.startDate
        );
      }
    },
    computedMaxDate(dueDate) {
      // REVIEW (m-computedMaxDate)
      let m = moment(dueDate, "jYYYY/jM/jD");
      m.subtract(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    computedMinDate(startDate) {
      // REVIEW (m-computedMinDate)
      let m = moment(startDate, "jYYYY/jM/jD");
      m.add(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    conditionalSelect(option, type) {
      // NOTE (m-conditionalSelect) to choose from options related to university informations
      if (option.text == "--گزینه مورد نظر خود را انتخاب نمایید--") {
        switch (type) {
          case "Cjob":
            this.prof.universityJobId = "";
            break;
          case "Cedu":
            this.prof.universityId = "";
            break;
          case "Ejob":
            this.executor.universityJob = "";
            break;
          case "Eedu":
            this.proposal.researcherUniversityId = "";
            break;
          case "Elast":
            this.executor.lastDegree = "";
            break;
          case "Clast":
            this.prof.lastDegree = "";
            break;
          case "Rlast":
            this.reviewer.lastDegree = "";
            break;
        }
      }
      this.$forceUpdate();
    },
    isEmail(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? null : false) : null;
    },
    isID(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? null : false) : null;
    },
    isEmailClass(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? true : false) : false;
    },
    isIDClass(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? true : false) : false;
    },
    selectMehvar(index, mehvar) {
      // NOTE (m-selectMehvar) to specify the selected mehvar
      this.selectedMehvar = index;
      this.proposal.mehvarId = mehvar.id;
      this.$forceUpdate();
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
      ////////////////
    },
    addAchievment() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.achievmentitems.push({
        name: "",
        amount: "",
        fullfill: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    // addOrgCost() {
    //   this.OrgCostItem.push({
    //     name: "",
    //     description: "",
    //     totalPrice: 0,
    //   });
    //     const title = (
    //   <div>
    //     <h5>هزینه جدید افزوده شد</h5>
    //     <span>
    //     لطفا اطلاعات هزینه‌های همکاری با موسسات را در جدول مربوطه تکمیل کنید
    //     </span>
    //   </div>
    // );

    // },

    // NOTE (m-addDeviceCost) to add device costs in the relevant sections

    // addDeviceCost() {

    //   this.deviceCostItem.push({
    //     name: "",
    //     consumable: "",
    //     fund: 0,
    //     source: "",
    //     number: 0,
    //     perPrice: 0,
    //     totalPrice: 0,
    //   });
    //     const title = (
    //   <div>
    //     <h5>هزینه جدید افزوده شد</h5>
    //     <span>
    //     لطفا اطلاعات هزینه‌های همکاری با موسسات را در جدول مربوطه تکمیل کنید
    //     </span>
    //   </div>
    // );

    // },
    // addCost1() {
    //   // NOTE (m-addCost1) to add personnel costs in the relevant sections
    //   this.PersonnelCostItem.push({
    //     name: "",
    //     degree: "",
    //     cooperationType: "",
    //     cooperationHour: 0,
    //     perPersonCost: 0,
    //   });
    //     const title = (
    //   <div>
    //     <h5>هزینه جدید افزوده شد</h5>
    //     <span>
    //     لطفا اطلاعات هزینه‌های همکاری با موسسات را در جدول مربوطه تکمیل کنید
    //     </span>
    //   </div>
    // );

    // },
    addService() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.proposal.gantData.push({
        description: "",
        percent: 0,
        startDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        dueDate: moment(new Date()).add(1, "day").format("jYYYY/jMM/jDD"),
        cellColor: "#000099",
      });
      const title = (
        <div>
          <h5>!فاز جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هر فاز را در جدول مربوطه تکمیل کنید و به منظور
            بروزرسانی گانت چارت روی دکمه بروزرسانی کلیک کنید
          </span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },
    delService(order) {
      // NOTE (m-delService) to remove services in the relevant sections
      this.proposal.gantData.splice(order, 1);
    },
    addprof() {
      // NOTE (m-addprof) to add profs in the relevant sections

      this.teachers.push(
        new Object({
          uploadPercentage: 0,
          resumeFile: "",
        })
      );

      const title = (
        <div>
          <h5>!استاد جدید افزوده شد</h5>
          <span>لطفا اطلاعات استاد جدید را در همین صفحه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    deleteprof(index) {
      // NOTE (m-deleteprof) to assign a number to the selected profs to be removed

      this.selectedprof = index;
      this.$refs["delprof"].show();
    },
    hideModal(type) {
      // NOTE (modal) to hide modal
      this.$refs[type].hide();
    },

    doDeleteprof() {
      // NOTE (m-deleteprof) to remove the selected prof
      this.teachers.splice(this.selectedprof, 1);
      this.selectedprof = "";
      this.$refs["delprof"].hide();
    },
    delFile(order, fileName) {
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    uploadFile(file, index, fileName) {
      // NOTE to upload files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.uploadedFiles[index].showProgress = true;
        this.uploadedFiles[index].variant = "info";
        this.uploadedFiles[index].uploadPercentage = 0;
        this.uploadedFiles[index].isUploaded = false;
        this.uploadedFiles[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/admin/request/phd/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.uploadedFiles[index].uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.uploadedFiles[index].isUploaded = true;
              this.uploadedFiles[index].uploadPercentage = 100;
              this.uploadedFiles[index].striped = false;
              this.uploadedFiles[index].variant = "success";
              this.uploadedFiles[index].uploadButDisable = false;
              this.proposal[fileName] = d.data.url;
              this.proposal[fileName + "Id"] = d.data.id;
              this.files[index] = d.data;
              this.files[index].title = this.fileTitles[index];
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.uploadedFiles[index].uploadPercentage = 0;
            this.uploadedFiles[index].isUploaded = false;
          });
      }
    },
    profUploadFile(file, index) {
      // NOTE  to upload colleagues files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.teachers[index].showProgress = true;
        this.teachers[index].variant = "info";
        this.teachers[index].uploadPercentage = 0;
        this.teachers[index].isUploaded = false;
        this.teachers[index].uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/admin/request/phd/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.teachers.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.teachers[index].resumeFile = d.data.url;
              this.teachers[index].resumeFileId = d.data.id;
              this.teachers[index].isUploaded = true;
              this.teachers[index].uploadPercentage = 100;
              this.teachers[index].striped = false;
              this.teachers[index].variant = "success";
              this.teachers[index].uploadButDisable = false;

              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.teachers[index].file = null;
            this.teachers[index].uploadPercentage = 0;
            this.teachers[index].isUploaded = false;
          });
      }
    },
    delFile(order, fileName) {
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    submitProposal() {
      // NOTE (m-submitProposal) to submit proposal
      this.isLoaded = false;
      this.sending = true;

      this.$http
        .post(
          this.baseUrl + "/setad/admin/request/phd/fastSub",
          {
            requestId: this.$route.params.id,
            researcherId: this.proposal.researcherId,
            uploadedFiles: this.files,
            faSubject: this.proposal.faSubject,
            enSubject: this.proposal.enSubject,
            dateProposalSubmission: this.proposal.dateProposalSubmission,
            masterThesisSubject: this.proposal.masterThesisSubject,
            bachelorProjectSubject: this.proposal.bachelorProjectSubject,
            initialIsSupported: this.proposal.initialIsSupported,
            initialSupportedType: this.proposal.initialSupportedType,
            initialOtherSupport: this.proposal.initialOtherSupport,
            initialSupportDescription: this.proposal.initialSupportDescription,
            universityId: this.proposal.universityId,
            otherUniversity: this.proposal.otherUniversity,
            mehvarId: this.proposal.mehvarId,
            otherMehvars: this.proposal.otherMehvars,
            typeStudy: this.proposal.typeStudy,
            typeSystemicDevelopmental: this.proposal.typeSystemicDevelopmental,
            typePractical: this.proposal.typePractical,
            zoneMedicine: this.proposal.zoneMedicine,
            zoneAgriculture: this.proposal.zoneAgriculture,
            zoneEnvironment: this.proposal.zoneEnvironment,
            zoneIndustrial: this.proposal.zoneIndustrial,
            zoneBioComputing: this.proposal.zoneBioComputing,
            zoneOther: this.proposal.zoneOther,
            researcherName: this.proposal.researcherName,
            researcherLastName: this.proposal.researcherLastName,
            researcherMobile: this.proposal.researcherMobile,
            researcherEmail: this.proposal.researcherEmail,
            researcherNatCode: this.proposal.researcherNatCode,
            researcherFax: this.proposal.researcherFax,
            researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
            researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
            researcherUniversityId: this.proposal.researcherUniversityId,
            researcherUniversityOther: this.proposal.researcherUniversityOther,
            researcherStudentNumber: this.proposal.researcherStudentNumber,
            teachers: this.teachers,
            // advisors: this.advisors,
            problemStatement: this.proposal.problemStatement,
            requestNecessity: this.proposal.requestNecessity,
            researchQuestions: this.proposal.researchQuestions,
            researchHypotheses: this.proposal.researchHypotheses,
            majorGoals: this.proposal.majorGoals,
            generalResearchMethod: this.proposal.generalResearchMethod,
            spatialScopeResearch: this.proposal.spatialScopeResearch,
            researchTimeDomain: this.proposal.researchTimeDomain,
            researchSampling: this.proposal.researchSampling,
            dataCollectionMethod: this.proposal.dataCollectionMethod,
            analysisMethod: this.proposal.analysisMethod,
            researchObstacles: this.proposal.researchObstacles,
            researchMacroTheoreticalFramework:
              this.proposal.researchMacroTheoreticalFramework,
            keywords: this.proposal.keywords,
            references: this.proposal.references,
            commercializingType: this.proposal.commercializingType,
            companyId:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyId
                : "",
            otherCompanyName:
              this.proposal.commercializingType == "company" &&
              this.proposal.companyId == this.notCompany
                ? this.proposal.otherCompanyName
                : "",
            otherCompanyRegistrationNumber:
              this.proposal.commercializingType == "company" &&
              this.proposal.companyId == this.notCompany
                ? this.proposal.otherCompanyRegistrationNumber
                : "",
            otherCompanyNationalId:
              this.proposal.commercializingType == "company" &&
              this.proposal.companyId == this.notCompany
                ? this.proposal.otherCompanyNationalId
                : "",
            companyProducts:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyProducts
                : "",
            companyAddress:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyAddress
                : "",
            companyPostalCode:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyPostalCode
                : "",
            companyTel:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyTel
                : "",
            companyEmail:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyEmail
                : "",
            companyDescription:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyDescription
                : "",
            acceleratorId:
              this.proposal.commercializingType == "accelerator"
                ? this.proposal.acceleratorId
                : "",
            commercializingObligation1:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation1
                : "",
            commercializingObligation2:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation2
                : "",
            gantData: this.proposal.gantData,
            duration: this.proposal.duration,
            finalDate: this.proposal.finalDate,
            roadMapFileId: this.proposal.roadMapFileId,
            researchModelFileId: this.proposal.researchModelFileId,
            theoreticalFoundationsFileId:
              this.proposal.theoreticalFoundationsFileId,
            internalResearchBackgroundFileId:
              this.proposal.internalResearchBackgroundFileId,
            foreignResearchBackgroundFileId:
              this.proposal.foreignResearchBackgroundFileId,
            letterPlaceDissertationFileId:
              this.proposal.letterPlaceDissertationFileId,
            minutesDefenceFileId: this.proposal.minutesDefenceFileId,
            proposalWordFileId: this.proposal.proposalWordFileId,
            proposalPdfFileId: this.proposal.proposalPdfFileId,
            letterCompanyFileId: this.proposal.letterCompanyFileId,
            letterUniversityAccountNumberFileId:
              this.proposal.letterUniversityAccountNumberFileId,
            otherFile1Id: this.proposal.otherFile1Id,
            otherFile1Title: this.proposal.otherFile1Title,
            otherFile1Description: this.proposal.otherFile1Description,
            otherFile2Id: this.proposal.otherFile2Id,
            otherFile2Title: this.proposal.otherFile2Title,
            otherFile2Description: this.proposal.otherFile2Description,
            otherFile3Id: this.proposal.otherFile3Id,
            otherFile3Title: this.proposal.otherFile3Title,
            otherFile3Description: this.proposal.otherFile3Description,
            promiseArrays: this.proposal.promiseArrays,
            startDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",
            finalDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.max(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast("درخواست با موفقیت در سامانه به ثبت رسید.", "success");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.sending = false;
          router.push("/admin/phdProposal/" + res.data);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          this.false = true;
        });
    },
    onMounted() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.uploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
      this.files = JSON.parse(JSON.stringify(this.files));
      let acc = 0;

      this.$http
        .post(
          this.baseUrl + "/setad/admin/researchers/select",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.researchers = res.data.map((x) => {
            return {
              id: x.id,
              text: x.name,
            };
          });

          this.researchers.unshift({
            id: 0,
            text: "--پژوهشگر مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });
        }),
        this.$http
          .post(
            this.baseUrl + "/setad/options/universities",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.universities = res.data;
            this.universities.push(
              new Object({
                id: this.notUniversity,
                text: "سایر دانشگاه ها",
              })
            );
            this.universities.unshift({
              id: 0,
              text: "--گزینه مورد نظر خود را انتخاب نمایید--",
              disabled: "true",
            });

            acc++;

            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch {}
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });

      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      /////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت ها",
            })
          );
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      /////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStatesAndCities() {
      this.$http
        .get(
          this.baseUrl + "/setad/public/states/list",
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    // NOTE unuversity class if the university was "سایر"

    universityClass() {
      if (this.proposal.researcherUniversityId == this.notUniversity) {
        if (this.proposal.researcherUniversityOther) {
          return "done";
        } else {
          return "required";
        }
      } else {
        if (this.proposal.researcherUniversityId) {
          return "done";
        } else {
          return "required";
        }
      }
    },
    computedMehvars() {
      // NOTE (c-computedMehvars) to after selecting university show to user list of mehvars of selected university
      let mehvarha = [];
      if (this.proposal.universityId) {
        mehvarha = this.mehvars.filter(
          (x) => x.universityId == this.proposal.universityId
        );
        if (this.proposal.universityId != this.notUniversity) {
          this.proposal.mehvarId = this.proposal.mehvarId;
        } else if (this.proposal.universityId == this.notUniversity) {
          this.proposal.mehvarId = this.notMehvar;
        }
      }

      if (this.proposal.universityId) {
        mehvarha.push(
          new Object({
            id: this.notMehvar,
            text: "سایر محورها",
            universityId: this.proposal.universityId,
          })
        );
      } else {
        mehvarha.push(
          new Object({
            id: 0,
            text: "لطفا ابتدا یک دانشگاه انتخاب کنید",
            universityId: this.proposal.universityId,
          })
        );
      }
      if (this.proposal.mehvarId)
        this.selectedMehvar = mehvarha.findIndex(
          (x) => x.id == this.proposal.mehvarId
        );
      else this.selectedMehvar = "-";
      // alert(mehvarha.map(y=>y.id))
      // this.proposal.mehvarId ? this.selectedMehvar = mehvarha.map(y=>y.id).findIndexOf(this.proposal.mehvarId) : this.selectedMehvar = ''
      return mehvarha;
    },
    computedTitle1() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyRegistrationNumber) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },
    computedTitle2() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyNationalId) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },
  },

  watch: {},
  mounted() {
    this.onMounted();
    this.getStatesAndCities();
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
.items-box {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
}
</style>
